export const shouldShowPlaceholder = (
  isIOSMeshesStudy: boolean,
  studyPreviewSrc?: string,
) => {
  return !studyPreviewSrc || isIOSMeshesStudy;
};
